import { render, staticRenderFns } from "./sideBarItem.vue?vue&type=template&id=4c8ef1ee&scoped=true&"
import script from "./sideBarItem.vue?vue&type=script&lang=js&"
export * from "./sideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./sideBarItem.vue?vue&type=style&index=0&id=4c8ef1ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ef1ee",
  null
  
)

export default component.exports